import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";

import {
  getSimpleAsideRoutes
} from '@/common/util'


Vue.use(VueRouter);

/** 注意： meta  key 一旦确定不可修改 且 同级唯一。 是作为识别这个对象的唯一标识！！！   */

// 用户管理
export const userManageRoutes = [
  {
    path: "/userList",
    name: "userList",
    meta: {
      title: "用户列表",
      key: 'user-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/userManage/userList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/userList.vue"),
  },
  {
    path: "/deviceGateList",
    name: "deviceGateList",
    meta: {
      title: "设备(总开关)列表",
      key: 'device-gate-list',
      asideHidden: true, // 侧边栏不显示
      pageApisPrm: import("../views/userManage/deviceGateList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/deviceGateList.vue"),
  },
  // deviceChildList
  {
    path: "/deviceChildList",
    name: "deviceChildList",
    meta: {
      title: "子设备列表",
      key: 'device-child-list',
      asideHidden: true, 
      pageApisPrm: import("../views/userManage/deviceChildList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "userManage" */ "../views/userManage/deviceChildList.vue"),
  },
]

// 设备管理
export const deviceManageRoutes = [
  {
    path: "/deviceManageList",
    name: "deviceManageList",
    meta: {
      title: "设备管理",
      key: 'device-manage-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/deviceManage/deviceList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "deviceManage" */ "../views/deviceManage/deviceList.vue"),
  },
]

// 硬件管理
export const hardwareUpgradeRoutes = [
  {
    path: '/hardwareUpgradeList',
    name: 'hardwareUpgradeList',
    meta: {
      title: "硬件升级",
      key: 'hardware-upgrade-list',
      asideHidden: false, // 侧边栏显示
      pageApisPrm: import("../views/hardwareManage/hardwareUpgradeList.vue").then(({ pageApiList }: any) => pageApiList)
    },
    component: () =>
      import(/* webpackChunkName: "hardwareManage" */ "../views/hardwareManage/hardwareUpgradeList.vue"),
  }
]


/**
 *  之前项目的某一管理大类，
 * 当前项目暂时没有
 *
 */
function getMidLen() {
  // const dbRoutesLen = dataWholeBoardRoutes.length
  // console.log(dbRoutesLen, 'dbRoutesLen')

  // const mMRoutesLen = merchantManageRoutes.length
  // console.log(mMRoutesLen, 'mMRoutesLen')

  const uMRoutesLen = userManageRoutes.length
  console.log(uMRoutesLen, 'uMRoutesLen')

  const dMRoutesLen = deviceManageRoutes.length
  console.log(uMRoutesLen, 'uMRoutesLen')

  const hwuMRoutesLen = hardwareUpgradeRoutes.length
  console.log(hwuMRoutesLen, 'hwuMRoutesLen')

  // const oMRoutesLen = operationManageRoutes.length
  // console.log(oMRoutesLen, 'oMRoutesLen')

  // const fMRoutesLen = financeManageRoutes.length
  // console.log(fMRoutesLen, 'fMRoutesLen')

  // const aMRoutesLen = auditManageRoutes.length
  // console.log(aMRoutesLen, 'aMRoutesLen')

  // const oWMRoutesLen = officialWebManageRoutes.length
  // console.log(oWMRoutesLen, 'oWMRoutesLen')

  // const marMRoutesLen = marketManageRoutes.length
  // console.log(marMRoutesLen, 'marMRoutesLen')

  // const cMRoutesLen = couponManageRoutes.length
  // console.log(cMRoutesLen, 'cMRoutesLen')

  // const sOLRoutesLen = systemManageRoutes.length
  // console.log(sOLRoutesLen, 'sOLRoutesLen')

  const totalLen = uMRoutesLen + dMRoutesLen + hwuMRoutesLen

  console.log(totalLen, 'totalLen')

  return totalLen / 2
}

// console.log(getMidLen(), 'getMidLen')

export const asideRoutes = [
  ...userManageRoutes,
  ...deviceManageRoutes,
  ...hardwareUpgradeRoutes
]



const routes = [
  {
    path: "/",
    redirect: () => {
      const token = localStorage.getItem('token')

      if (token) {
        // const menusStr = localStorage.getItem('menus')

        const menus: any[] = getSimpleAsideRoutes()

        // console.log(menus, 'menus')

        const [
          fisrtRouteItem = {}
        ] = menus

        if (fisrtRouteItem.children instanceof Array) {
          const [child] = (fisrtRouteItem.children as any) || []

          return child.url || "/login";
        } else {
          return fisrtRouteItem.url || "/login"
        }
      } else {
        return "/login"
      }
    },
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      ...asideRoutes
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
